// menu
$(function () {
    $(".text-menu, .hamburger, .close").click(function () {
        $(".mobile-menu").toggleClass("open");
    });

    $(".arrow").on("click", function () {
        var $this = $(this);

        if (!$this.hasClass("active")) {
            $(".content").slideUp("slow");
            $(".arrow").removeClass("active");
            $(".main-divider").removeClass("active");
        }

        $this.toggleClass("active");
        $this.parent().parent().find(".content").slideToggle("slow");
        $this.parent().parent().find(".main-divider").toggleClass("active");
    });

    $('.modal-close').click(function(e) {
      e.preventDefault();
      $(this).closest('.modal').hide();
      $('.modal-backdrop').hide();
      $('body').removeClass('modal-open')
    });

    $('[data-toggle=modal]').click(function(e) {
      e.preventDefault();
      $($(this).attr('href')).show();
      $('.modal-backdrop').show();
      $('body').addClass('modal-open')
    });

    $('#buy-werk-form').submit(function (e) {
      e.preventDefault();

      var f = $(this);
      var data = $(f).serialize();

      $.post('https://cryptwerk.com/api/werk-coin/buy', data, function(data) {
        if (data.result === 'success') {
          $(f).html('<p>Thank you for your request. Our manager will contact you soon.</p>')
        } else {
          alert(data.error.title)
        }
      }, 'json');
    });

    // load goods from market
  $.get('https://cryptwerk.com/api/market/products/random/?limit=30', function(response) {
    if (response) {
      $(response.data).each(function(i, item) {
        let row = '#goods-row-' + Math.ceil((i+1) / 10)
        $(row).append('<div class="item">\n' +
          '                <picture>\n' +
          '                    <a href="' + item.url + '" ref="nofollow noopener" target="_blank"><img src="' + item.imageUrl + '" alt=""></a>\n' +
          '                </picture>\n' +
          '                <div class="brand">\n' +
          '                    <a href="' + item.company.url + '" ref="nofollow noopener" target="_blank">' + item.company.title + '</a>\n' +
          '                </div>\n' +
          '                <div class="title">\n' +
          '                    <a href="' + item.url + '" ref="nofollow noopener" target="_blank">' + item.title + '</a>\n' +
          '                </div>\n' +
          '                <div class="price">\n' +
          '                    <span class="currency">$</span>\n' +
          '                    <span>' + item.price + '</span>\n' +
          '                </div>\n' +
          '            </div>')
      });

      $('.owl-carousel').owlCarousel({
        items: 10, // goods in a row
        loop: true,
        autoplay: true,
        slideTransition: 'linear',
        autoplayTimeout: 0,
        autoplaySpeed: 20000, // scroll speed
        autoplayHoverPause: false,
        autoWidth: true,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        dots: false
      });

      $('.owl-carousel2').owlCarousel({
        items: 10, // goods in a row
        loop: true,
        rtl: true,
        autoplay: true,
        slideTransition: 'linear',
        autoplayTimeout: 0,
        autoplaySpeed: 20000, // scroll speed
        autoplayHoverPause: false,
        autoWidth: true,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        dots: false
      });
    }
  }, 'json')
});

// elements animation on scroll
$(function ($) {
    // Function which adds the 'animated' class to any '.animatable' in view
    var doAnimations = function () {
        // Calc current offset and get all animatables
        var offset = $(window).scrollTop() + $(window).height(),
            $animatables = $('.animatable');

        // Unbind scroll handler if we have no animatables
        if ($animatables.length == 0) {
            $(window).off('scroll', doAnimations);
        }

        // Check all animatables and animate them if necessary
        $animatables.each(function (i) {
            var $animatable = $(this);
            if (($animatable.offset().top + $animatable.height() - 300) < offset) {
                $animatable.removeClass('animatable').addClass('animated');
            }
            if ($(".pie").hasClass("animated")) {
                $(".slice").css("animation:", "bake-pie 15s")
            }
        });

    };

    // Hook doAnimations on scroll, and trigger a scroll
    $(window).on('scroll', doAnimations);
    $(window).trigger('scroll');

});

// floating menu
$(window).bind('scroll', function () {
  if ($(window).scrollTop() > 50) {
    $('.topline').addClass('fixed');
  } else {
    $('.topline').removeClass('fixed');
  }
});


$(".home").click(function (e) {
    e.preventDefault();
    $('html, body').animate({scrollTop: 0}, '3000');
    if ($(".mobile-menu").hasClass("open")) {
        $(".mobile-menu").removeClass("open")
    }
});


$("[data-toggle=menu]").click(function (e) {
    e.preventDefault();
    if ($(".mobile-menu").hasClass("open")) {
        $(".mobile-menu").removeClass("open")
    }
    var position = $($(this).attr("href")).offset().top - 70;

    $("body, html").animate({
        scrollTop: position
    }, "5000");
});
